import StaffShell from "../components/StaffShell";
import KitchenQueue from "../components/KitchenQueue";
import { T, useI18n } from "../lib/i18n";

export default function KitchenDash() {
  useI18n();
  return (
    <StaffShell title={T("Kitchen line")} subtitle={T("Tickets in real time")}>
      <KitchenQueue />
    </StaffShell>
  );
}
